import axios from 'axios'; // 引入axios
// axios.defaults.baseURL = 'http://192.168.0.10:81/api/';
axios.defaults.baseURL = 'https://df-ydtg-api.yunlib.cn/Book/';
axios.defaults.timeout = 5000;
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data;
    return res;
  },
  error => {
    return Promise.reject(error)
  }
)
export default axios;
// window.location.host



// WEBPACK FOOTER //
// ./src/common/Axios.js